var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLts3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 86,
    viewBox: "0 0 107 86",
    fill: "none",
    id: "svg31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_6453)",
    id: "g31"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M87.3061 78.0547V78.0547C87.3061 60.5051 73.0793 46.2783 55.5297 46.2783H50.8379C33.2883 46.2783 19.0615 60.5051 19.0615 78.0547V78.0547",
    stroke: "#AA5939",
    strokeWidth: 2.4483,
    id: "path1",
    style: {
      stroke: "#f47a00",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.883 71.3089L98.7735 70.6348C98.4231 70.5588 98.077 70.78 97.9988 71.1299L97.1098 75.1074C97.0338 75.4471 97.2381 75.7866 97.5739 75.8786L100.551 76.6942C101.608 76.9837 102.696 76.3489 102.965 75.2864L103.365 73.7004C103.636 72.6274 102.964 71.5434 101.883 71.3089Z",
    fill: "#AA5939",
    stroke: "#AA5939",
    strokeWidth: 1.95659,
    id: "path2",
    style: {
      stroke: "#f47a00",
      strokeOpacity: 1,
      fill: "#f47a00",
      fillOpacity: 1
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.8342 76.9995L82.0285 76.7871C81.0699 76.5343 80.4174 75.6474 80.4613 74.6571L80.6661 70.0349L80.429 65.618C80.4014 65.1022 80.5642 64.5942 80.8865 64.1906L83.2499 61.2315C83.7293 60.6312 84.4976 60.3395 85.2547 60.4704L93.3247 61.8662C93.5355 61.9027 93.7396 61.9711 93.9299 62.069L98.5472 64.4463C99.1631 64.7634 99.5837 65.363 99.6722 66.0501L100.216 70.2727C100.251 70.545 100.232 70.8216 100.161 71.0868L99.4457 73.7569L98.6525 76.7171C98.3402 77.8825 97.1423 78.5742 95.9768 78.2619C94.8113 77.9496 94.1197 76.7516 94.432 75.5862L94.1485 76.6441C93.8362 77.8095 92.6383 78.5012 91.4728 78.1889C90.3073 77.8766 89.6157 76.6786 89.928 75.5132L89.8349 75.8605C89.5226 77.026 88.3247 77.7176 87.1592 77.4053C85.9937 77.093 85.5112 75.1148 85.8235 73.9494L85.4058 75.508C85.1056 76.6285 83.9559 77.2953 82.8342 76.9995Z",
    fill: "#F8F8F8",
    id: "path3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.0285 76.7871L81.7599 77.8054L82.0285 76.7871ZM82.8342 76.9995L82.5656 78.0179L82.8342 76.9995ZM85.7668 70.0917C85.9173 69.5298 86.4948 69.1964 87.0567 69.3469C87.6185 69.4975 87.9519 70.075 87.8014 70.6368L85.7668 70.0917ZM80.8865 64.1906L81.7094 64.8479L80.8865 64.1906ZM83.2499 61.2315L82.4269 60.5742L82.427 60.5742L83.2499 61.2315ZM99.6722 66.0501L100.717 65.9156L99.6722 66.0501ZM100.216 70.2727L99.1711 70.4072L99.1711 70.4072L100.216 70.2727ZM89.9873 71.2225C90.1379 70.6607 90.7154 70.3273 91.2772 70.4778C91.839 70.6284 92.1724 71.2059 92.0219 71.7677L89.9873 71.2225ZM94.2078 72.3534C94.3584 71.7916 94.9359 71.4582 95.4977 71.6087C96.0596 71.7593 96.393 72.3368 96.2424 72.8986L94.2078 72.3534ZM99.4457 73.7569L98.4284 73.4843L98.4284 73.4843L99.4457 73.7569ZM100.161 71.0868L101.178 71.3594L101.178 71.3594L100.161 71.0868ZM85.2547 60.4704L85.0752 61.5082L85.2547 60.4704ZM93.3247 61.8662L93.5042 60.8284L93.3247 61.8662ZM93.9299 62.069L93.4478 63.0054L93.4478 63.0054L93.9299 62.069ZM98.5472 64.4463L99.0293 63.5099L99.0293 63.5099L98.5472 64.4463ZM80.429 65.618L79.3774 65.6744L79.3774 65.6744L80.429 65.618ZM80.6661 70.0349L81.7178 69.9785L81.7206 70.03L81.7183 70.0815L80.6661 70.0349ZM80.4613 74.6571L79.4091 74.6104L79.4091 74.6104L80.4613 74.6571ZM82.297 75.7687L83.1027 75.9812L82.5656 78.0179L81.7599 77.8054L82.297 75.7687ZM84.3885 75.2354L84.8062 73.6768L86.8407 74.2219L86.4231 75.7805L84.3885 75.2354ZM84.8062 73.6768L85.7668 70.0917L87.8014 70.6368L86.8407 74.2219L84.8062 73.6768ZM80.0636 63.5334L82.4269 60.5742L84.0728 61.8887L81.7094 64.8479L80.0636 63.5334ZM100.717 65.9156L101.26 70.1383L99.1711 70.4072L98.6276 66.1845L100.717 65.9156ZM88.8176 75.5879L88.9107 75.2406L90.9453 75.7858L90.8522 76.1331L88.8176 75.5879ZM88.9107 75.2406L89.9873 71.2225L92.0219 71.7677L90.9453 75.7858L88.9107 75.2406ZM87.4318 76.388C88.0354 76.5498 88.6559 76.1915 88.8176 75.5879L90.8522 76.1331C90.3894 77.8604 88.6139 78.8854 86.8866 78.4226L87.4318 76.388ZM86.8407 74.2219C86.747 74.5716 86.7623 75.1443 86.9359 75.6631C87.1222 76.2198 87.3613 76.3691 87.4318 76.388L86.8866 78.4226C85.7916 78.1292 85.2067 77.1333 84.9384 76.3315C84.6574 75.4917 84.5876 74.4925 84.8062 73.6768L86.8407 74.2219ZM93.1312 76.3715L93.4147 75.3136L95.4493 75.8588L95.1658 76.9166L93.1312 76.3715ZM93.4147 75.3136L94.2078 72.3534L96.2424 72.8986L95.4493 75.8588L93.4147 75.3136ZM91.7454 77.1716C92.349 77.3333 92.9695 76.9751 93.1312 76.3715L95.1658 76.9166C94.703 78.6439 92.9275 79.669 91.2002 79.2062L91.7454 77.1716ZM90.9453 75.7858C90.7835 76.3894 91.1417 77.0099 91.7454 77.1716L91.2002 79.2062C89.4729 78.7433 88.4479 76.9679 88.9107 75.2406L90.9453 75.7858ZM96.2494 77.2446C96.853 77.4063 97.4735 77.0481 97.6352 76.4445L99.6698 76.9896C99.207 78.7169 97.4315 79.742 95.7042 79.2792L96.2494 77.2446ZM95.4493 75.8588C95.2875 76.4624 95.6457 77.0828 96.2494 77.2446L95.7042 79.2792C93.9769 78.8163 92.9518 77.0409 93.4147 75.3136L95.4493 75.8588ZM97.6352 76.4445L98.4284 73.4843L100.463 74.0295L99.6698 76.9896L97.6352 76.4445ZM101.178 71.3594L100.463 74.0295L98.4284 73.4843L99.1438 70.8142L101.178 71.3594ZM85.4342 59.4327L93.5042 60.8284L93.1452 62.904L85.0752 61.5082L85.4342 59.4327ZM94.4119 61.1327L99.0293 63.5099L98.0651 65.3826L93.4478 63.0054L94.4119 61.1327ZM81.4807 65.5615L81.7178 69.9785L79.6145 70.0914L79.3774 65.6744L81.4807 65.5615ZM81.7183 70.0815L81.5134 74.7037L79.4091 74.6104L79.614 69.9883L81.7183 70.0815ZM93.5042 60.8284C93.8205 60.8832 94.1266 60.9857 94.4119 61.1327L93.4478 63.0054C93.3526 62.9564 93.2506 62.9222 93.1452 62.904L93.5042 60.8284ZM101.26 70.1383C101.313 70.5468 101.285 70.9616 101.178 71.3594L99.1438 70.8142C99.1794 70.6816 99.1886 70.5433 99.1711 70.4072L101.26 70.1383ZM98.6276 66.1845C98.5834 65.841 98.3731 65.5412 98.0651 65.3826L99.0293 63.5099C99.9532 63.9855 100.584 64.885 100.717 65.9156L98.6276 66.1845ZM82.427 60.5742C83.1462 59.6737 84.2986 59.2363 85.4342 59.4327L85.0752 61.5082C84.6967 61.4427 84.3125 61.5886 84.0728 61.8887L82.427 60.5742ZM83.1027 75.9812C83.6636 76.1291 84.2384 75.7956 84.3885 75.2354L86.4231 75.7805C85.9728 77.4613 84.2482 78.4616 82.5656 78.0179L83.1027 75.9812ZM81.7599 77.8054C80.3221 77.4263 79.3433 76.0959 79.4091 74.6104L81.5134 74.7037C81.4915 75.1989 81.8178 75.6423 82.297 75.7687L81.7599 77.8054ZM81.7094 64.8479C81.5483 65.0497 81.4669 65.3036 81.4807 65.5615L79.3774 65.6744C79.3359 64.9007 79.5801 64.1388 80.0636 63.5334L81.7094 64.8479Z",
    fill: "#AA5939",
    id: "path4",
    style: {
      fill: "#f47a00",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.1272,
    y: 68.9817,
    width: 3.86164,
    height: 5.52155,
    rx: 1.93082,
    transform: "rotate(15 76.1272 68.9817)",
    fill: "#F8F8F8",
    stroke: "#AA5939",
    strokeWidth: 2.10635,
    id: "rect4",
    style: {
      stroke: "#f47a00",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.97058 72.2872L8.08001 71.6131C8.43044 71.5371 8.77647 71.7583 8.85469 72.1082L9.74374 76.0856C9.81969 76.4254 9.61537 76.7649 9.27959 76.8569L6.30284 77.6725C5.24592 77.962 4.15729 77.3271 3.88886 76.2647L3.48816 74.6786C3.2171 73.6057 3.88907 72.5217 4.97058 72.2872Z",
    fill: "#AA5939",
    stroke: "#AA5939",
    strokeWidth: 1.95659,
    id: "path5",
    style: {
      stroke: "#f47a00",
      strokeOpacity: 1,
      fill: "#f47a00",
      fillOpacity: 1
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6966 77.3495L25.4715 77.0432C26.3933 76.6788 26.9364 75.7209 26.7757 74.7427L26.0254 70.1773L25.7382 65.7633C25.7047 65.2479 25.4829 64.7627 25.1151 64.4001L22.4183 61.7414C21.8711 61.202 21.0737 61.0033 20.3375 61.2229L12.4893 63.5636C12.2843 63.6247 12.0897 63.7168 11.9124 63.8366L7.60869 66.7434C7.03463 67.1311 6.68792 67.7763 6.6814 68.469L6.64129 72.7263C6.63871 73.0009 6.68982 73.2733 6.79176 73.5282L7.81809 76.0949L8.95591 78.9405C9.40389 80.0608 10.6753 80.6058 11.7956 80.1579C12.9159 79.7099 13.461 78.4385 13.013 77.3182L13.4196 78.3351C13.8676 79.4554 15.139 80.0005 16.2593 79.5525C17.3796 79.1045 17.9247 77.8332 17.4767 76.7128L17.6102 77.0467C18.0582 78.167 19.3296 78.7121 20.4499 78.2641C21.5702 77.8161 21.8154 75.7947 21.3674 74.6744L21.9665 76.1726C22.3972 77.2498 23.6177 77.7759 24.6966 77.3495Z",
    fill: "#F8F8F8",
    id: "path6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.4715 77.0432L25.8586 78.0226L25.4715 77.0432ZM24.6966 77.3495L25.0837 78.3289L24.6966 77.3495ZM20.9673 70.8371C20.7513 70.297 20.1384 70.0343 19.5983 70.2502C19.0583 70.4662 18.7955 71.0791 19.0115 71.6191L20.9673 70.8371ZM25.1151 64.4001L25.8545 63.6501L25.8545 63.6501L25.1151 64.4001ZM22.4183 61.7414L21.6789 62.4914L21.6789 62.4914L22.4183 61.7414ZM6.6814 68.469L7.73452 68.479L7.73452 68.479L6.6814 68.469ZM6.64129 72.7263L5.58816 72.7164L5.58816 72.7164L6.64129 72.7263ZM16.9102 72.4594C16.6942 71.9193 16.0813 71.6565 15.5413 71.8725C15.0012 72.0884 14.7384 72.7013 14.9544 73.2414L16.9102 72.4594ZM12.8531 74.0816C12.6371 73.5416 12.0242 73.2788 11.4842 73.4948C10.9441 73.7107 10.6813 74.3236 10.8973 74.8637L12.8531 74.0816ZM7.81809 76.0949L8.79599 75.7039L8.79598 75.7039L7.81809 76.0949ZM6.79176 73.5282L5.81386 73.9192L5.81387 73.9192L6.79176 73.5282ZM20.3375 61.2229L20.6385 62.2321L20.3375 61.2229ZM12.4893 63.5636L12.1883 62.5543L12.4893 63.5636ZM11.9124 63.8366L12.5019 64.7093L12.5019 64.7093L11.9124 63.8366ZM7.60869 66.7434L8.19817 67.6161L7.60869 66.7434ZM25.7382 65.7633L26.7892 65.695L26.7892 65.695L25.7382 65.7633ZM26.0254 70.1773L24.9744 70.2456L24.9778 70.2971L24.9862 70.3481L26.0254 70.1773ZM26.7757 74.7427L25.7364 74.9135L25.7364 74.9135L26.7757 74.7427ZM25.0843 76.0637L24.3094 76.37L25.0837 78.3289L25.8586 78.0226L25.0843 76.0637ZM22.9444 75.7816L22.3453 74.2834L20.3895 75.0654L20.9886 76.5637L22.9444 75.7816ZM22.3453 74.2834L20.9673 70.8371L19.0115 71.6191L20.3895 75.0654L22.3453 74.2834ZM25.8545 63.6501L23.1577 60.9914L21.6789 62.4914L24.3757 65.1501L25.8545 63.6501ZM5.62827 68.4591L5.58816 72.7164L7.69442 72.7362L7.73452 68.479L5.62827 68.4591ZM18.5881 76.6557L18.4546 76.3218L16.4988 77.1039L16.6323 77.4377L18.5881 76.6557ZM18.4546 76.3218L16.9102 72.4594L14.9544 73.2414L16.4988 77.1039L18.4546 76.3218ZM20.0589 77.2862C19.4786 77.5182 18.8201 77.2359 18.5881 76.6557L16.6323 77.4377C17.2963 79.0981 19.1805 79.9059 20.8409 79.242L20.0589 77.2862ZM20.3895 75.0654C20.5239 75.4016 20.5765 75.9721 20.4655 76.5077C20.3464 77.0825 20.1266 77.2591 20.0589 77.2862L20.8409 79.242C21.8935 78.8211 22.3565 77.763 22.528 76.9351C22.7077 76.0679 22.6589 75.0676 22.3453 74.2834L20.3895 75.0654ZM14.3975 77.9441L13.9909 76.9272L12.0351 77.7092L12.4417 78.7261L14.3975 77.9441ZM13.9909 76.9272L12.8531 74.0816L10.8973 74.8637L12.0351 77.7092L13.9909 76.9272ZM15.8683 78.5746C15.288 78.8066 14.6295 78.5243 14.3975 77.9441L12.4417 78.7261C13.1057 80.3865 14.9899 81.1943 16.6503 80.5304L15.8683 78.5746ZM16.4988 77.1039C16.7309 77.6841 16.4485 78.3426 15.8683 78.5746L16.6503 80.5304C18.3107 79.8665 19.1185 77.9822 18.4546 76.3218L16.4988 77.1039ZM11.4046 79.18C10.8243 79.412 10.1658 79.1297 9.9338 78.5494L7.97801 79.3315C8.64195 80.9919 10.5262 81.7997 12.1866 81.1358L11.4046 79.18ZM12.0351 77.7092C12.2671 78.2895 11.9848 78.9479 11.4046 79.18L12.1866 81.1358C13.847 80.4718 14.6548 78.5876 13.9909 76.9272L12.0351 77.7092ZM9.9338 78.5494L8.79599 75.7039L6.8402 76.4859L7.97801 79.3315L9.9338 78.5494ZM5.81387 73.9192L6.8402 76.4859L8.79598 75.7039L7.76965 73.1372L5.81387 73.9192ZM20.0365 60.2136L12.1883 62.5543L12.7903 64.5728L20.6385 62.2321L20.0365 60.2136ZM11.3229 62.9638L7.01922 65.8706L8.19817 67.6161L12.5019 64.7093L11.3229 62.9638ZM24.6873 65.8317L24.9744 70.2456L27.0763 70.1089L26.7892 65.695L24.6873 65.8317ZM24.9862 70.3481L25.7364 74.9135L27.8149 74.572L27.0646 70.0065L24.9862 70.3481ZM12.1883 62.5543C11.8807 62.6461 11.5889 62.7842 11.3229 62.9638L12.5019 64.7093C12.5905 64.6494 12.6878 64.6034 12.7903 64.5728L12.1883 62.5543ZM5.58816 72.7164C5.58429 73.1282 5.66096 73.5368 5.81386 73.9192L7.76965 73.1372C7.71868 73.0097 7.69313 72.8735 7.69442 72.7362L5.58816 72.7164ZM7.73452 68.479C7.73779 68.1326 7.91114 67.81 8.19817 67.6161L7.01922 65.8706C6.15813 66.4522 5.63806 67.4201 5.62827 68.4591L7.73452 68.479ZM23.1577 60.9914C22.337 60.1823 21.1408 59.8842 20.0365 60.2136L20.6385 62.2321C21.0066 62.1223 21.4053 62.2217 21.6789 62.4914L23.1577 60.9914ZM24.3094 76.37C23.77 76.5832 23.1597 76.3202 22.9444 75.7816L20.9886 76.5637C21.6346 78.1793 23.4655 78.9685 25.0837 78.3289L24.3094 76.37ZM25.8586 78.0226C27.2414 77.476 28.056 76.0392 27.8149 74.572L25.7364 74.9135C25.8168 75.4026 25.5453 75.8815 25.0843 76.0637L25.8586 78.0226ZM24.3757 65.1501C24.5596 65.3314 24.6705 65.574 24.6873 65.8317L26.7892 65.695C26.7389 64.9218 26.4063 64.1941 25.8545 63.6501L24.3757 65.1501Z",
    fill: "#AA5939",
    id: "path7",
    style: {
      fill: "#f47a00",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.86164,
    height: 5.52155,
    rx: 1.93082,
    transform: "matrix(-0.928521 0.371279 0.371279 0.928521 30.408 68.5942)",
    fill: "#DDBDB0",
    stroke: "#AA5939",
    strokeWidth: 2.10635,
    id: "rect7",
    style: {
      stroke: "#f47a00",
      strokeOpacity: 1,
      fill: "#f8f8f8",
      fillOpacity: 1
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.501 38.3415V41.8162C70.501 42.0564 70.7262 42.2362 70.9661 42.2488C72.6684 42.3382 74.9503 44.6266 72.3785 47.5414C70.8263 49.3006 68.8112 47.9169 68.4357 47.7291C65.6225 53.7372 63.7419 59.3351 53.6032 59.3351C43.4645 59.3351 41.5839 53.7372 38.7707 47.7291C38.3952 47.9169 36.0046 49.0204 34.4524 47.2612C31.8765 44.3419 34.4837 42.0552 36.2405 41.9732C36.4805 41.962 36.7054 41.7813 36.7054 41.5411V38.3415C36.9558 37.1524 40.6858 34.7742 53.6032 34.7742C66.5206 34.7742 70.2506 37.1524 70.501 38.3415Z",
    fill: "#F8F8F8",
    id: "path8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.0809 42.2895C35.3912 41.914 32.0116 44.3497 34.8279 47.5415C36.3801 49.3007 38.3952 47.917 38.7707 47.7293C41.5839 53.7374 43.4645 59.3353 53.6032 59.3353C63.7419 59.3353 65.6225 53.7374 68.4357 47.7293C68.8112 47.917 70.8263 49.3007 72.3785 47.5415C75.1948 44.3497 71.8153 41.914 70.1255 42.2895M77.8234 30.8315C77.8234 17.4551 66.9796 6.61133 53.6032 6.61133C40.2268 6.61133 29.3831 17.4551 29.3831 30.8315C29.3831 32.0734 29.4765 33.2935 29.6568 34.4851C29.9103 36.1601 30.8568 37.6287 32.1208 38.7566L36.0799 42.2895C36.3219 42.5055 36.7054 42.3337 36.7054 42.0093V38.3416C36.9558 37.1525 40.6858 34.7743 53.6032 34.7743C66.5206 34.7743 70.2506 37.1525 70.501 38.3416V42.0093C70.501 42.3337 70.8845 42.5055 71.1265 42.2895L75.0856 38.7566C76.3497 37.6287 77.2962 36.1601 77.5496 34.4851C77.7299 33.2935 77.8234 32.0734 77.8234 30.8315Z",
    stroke: "#AA5939",
    strokeWidth: 2.25304,
    id: "path9",
    style: {
      stroke: "#f47a00",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0809 42.2895C35.3912 41.914 32.0116 44.3497 34.8279 47.5415C36.3801 49.3007 38.3952 47.917 38.7707 47.7293C41.5839 53.7374 43.4645 59.3353 53.6032 59.3353C63.7419 59.3353 65.6225 53.7374 68.4357 47.7293C68.8112 47.917 70.8263 49.3007 72.3785 47.5415C75.1948 44.3497 71.8153 41.914 70.1255 42.2895M77.8234 30.8315C77.8234 17.4551 66.9796 6.61133 53.6032 6.61133C40.2268 6.61133 29.3831 17.4551 29.3831 30.8315C29.3831 32.0734 29.4765 33.2935 29.6568 34.4851C29.9103 36.1601 30.8568 37.6287 32.1208 38.7566L36.0799 42.2895C36.3219 42.5055 36.7054 42.3337 36.7054 42.0093V38.3416C36.9558 37.1525 40.6858 34.7743 53.6032 34.7743C66.5206 34.7743 70.2506 37.1525 70.501 38.3416V42.0093C70.501 42.3337 70.8845 42.5055 71.1265 42.2895L75.0856 38.7566C76.3497 37.6287 77.2962 36.1601 77.5496 34.4851C77.7299 33.2935 77.8234 32.0734 77.8234 30.8315Z",
    stroke: "#AA5939",
    strokeWidth: 2.25304,
    id: "path10",
    style: {
      stroke: "#f47a00",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6016 32.8277C39.3377 31.6519 43.8535 30.2971 53.6032 30.2971C63.353 30.2971 67.8688 31.6519 69.6049 32.8277",
    stroke: "#AA5939",
    strokeWidth: 2.25304,
    strokeLinecap: "round",
    id: "path11",
    style: {
      stroke: "#f47a00",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7488 6.72925L52.2429 20.8106C52.2686 21.5434 52.87 22.1241 53.6032 22.1241V22.1241C54.3364 22.1241 54.9379 21.5434 54.9636 20.8106L55.4577 6.72925",
    stroke: "#AA5939",
    strokeWidth: 1.88518,
    id: "path12",
    style: {
      stroke: "#f47a00",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3278 11.2065L63.5028 23.5928C63.2864 24.2937 62.5546 24.698 61.8461 24.5081V24.5081C61.1372 24.3182 60.7056 23.6016 60.8692 22.8862L63.9977 9.20346",
    stroke: "#AA5939",
    strokeWidth: 1.88518,
    id: "path13",
    style: {
      stroke: "#f47a00",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7223 11.0999L43.4894 23.3173C43.7529 24.1719 44.6451 24.6651 45.5089 24.4336V24.4336C46.3732 24.2021 46.8993 23.3282 46.6995 22.456L43.6095 8.9679",
    stroke: "#AA5939",
    strokeWidth: 1.88518,
    id: "path14",
    style: {
      stroke: "#f47a00",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1264 66.3898L57.9566 70.0585C57.6332 70.1277 57.4127 70.4279 57.4435 70.7572L57.8097 74.6632C57.8463 75.0533 58.2161 75.3233 58.5988 75.2394L75.0137 71.6396C75.9685 71.4302 76.9592 71.4497 77.9049 71.6964L78.7957 71.9288C79.6814 72.1598 80.6238 71.9258 81.2985 71.3074L81.3608 71.2502C81.8783 70.7759 82.1729 70.1062 82.1729 69.4043C82.1729 68.2362 81.3654 67.2233 80.2267 66.9631L77.8017 66.4088C76.9219 66.2077 76.0089 66.2012 75.1264 66.3898Z",
    fill: "#AA5939",
    stroke: "#AA5939",
    strokeWidth: 1.95659,
    id: "path15",
    style: {
      stroke: "#f47a00",
      strokeOpacity: 1,
      fill: "#f47a00",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7734 17.0906L68.667 26.9883C68.3289 27.6437 68.5652 28.4492 69.2039 28.8179V28.8179C69.8404 29.1854 70.6531 28.9902 71.0532 28.3738L75.7764 21.0987",
    stroke: "#AA5939",
    strokeWidth: 1.88518,
    id: "path16",
    style: {
      stroke: "#f47a00",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5477 21.4572L36.0241 28.3722C36.4236 28.9893 37.2365 29.1851 37.8731 28.8175V28.8175C38.5114 28.449 38.7476 27.6441 38.4097 26.9891L33.732 17.9224",
    stroke: "#AA5939",
    strokeWidth: 1.88518,
    id: "path17",
    style: {
      stroke: "#f47a00",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2878 44.4875V45.8018",
    stroke: "#AA5939",
    strokeWidth: 2.88262,
    strokeLinecap: "round",
    id: "path18",
    style: {
      stroke: "#f47a00",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9573 44.4875V45.8018",
    stroke: "#AA5939",
    strokeWidth: 2.88262,
    strokeLinecap: "round",
    id: "path19",
    style: {
      stroke: "#f47a00",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7706 46.482L52.3983 43.4981C52.831 42.7047 53.9748 42.7182 54.3887 43.5216L55.9382 46.5294C56.3137 47.2584 56.0546 48.1539 55.3477 48.5697L54.7111 48.9442C53.9085 49.4163 52.9159 49.4285 52.1019 48.9763L51.377 48.5736C50.6348 48.1613 50.3641 47.2274 50.7706 46.482Z",
    fill: "#AA5939",
    id: "path20",
    style: {
      fill: "#f47a00",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8547 40.7458C60.8648 40.5956 60.6383 40.6832 61.5771 40.7458",
    stroke: "#AA5939",
    strokeWidth: 2.88262,
    strokeLinecap: "round",
    id: "path21",
    style: {
      stroke: "#f47a00",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4954 40.7458C46.4853 40.5956 46.7118 40.6832 45.773 40.7458",
    stroke: "#AA5939",
    strokeWidth: 2.88262,
    strokeLinecap: "round",
    id: "path22",
    style: {
      stroke: "#f47a00",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4074 54.1189V54.1189C54.1795 53.5607 52.7702 53.5607 51.5422 54.1189V54.1189",
    stroke: "#AA5939",
    strokeWidth: 2.14917,
    strokeLinecap: "round",
    id: "path23",
    style: {
      stroke: "#f47a00",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7271 66.3898L48.8969 70.0585C49.2203 70.1277 49.4408 70.4279 49.41 70.7572L49.0438 74.6632C49.0072 75.0533 48.6374 75.3233 48.2547 75.2394L31.8398 71.6396C30.8851 71.4302 29.8944 71.4497 28.9486 71.6964L28.0578 71.9288C27.1721 72.1598 26.2298 71.9258 25.5551 71.3074L25.4927 71.2502C24.9753 70.7759 24.6807 70.1062 24.6807 69.4043C24.6807 68.2362 25.4882 67.2233 26.6268 66.9631L29.0518 66.4088C29.9316 66.2077 30.8446 66.2012 31.7271 66.3898Z",
    fill: "#AA5939",
    stroke: "#AA5939",
    strokeWidth: 1.95659,
    id: "path24",
    style: {
      stroke: "#f47a00",
      strokeOpacity: 1,
      fill: "#f47a00",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8132 85.3059V78.5171C55.8132 78.3246 55.8982 78.142 56.0455 78.0181L57.5375 76.7625C57.6998 76.626 57.7855 76.4191 57.7674 76.2078L57.1663 69.1891C57.147 68.9638 57.0123 68.7645 56.8104 68.6626L55.6213 68.0622C55.5302 68.0162 55.4295 67.9922 55.3274 67.9922H53.2916H51.2706C51.1865 67.9922 51.1032 68.0124 51.0251 68.0519L49.8597 68.6403C49.6326 68.7549 49.4743 69.0184 49.448 69.3253L48.8728 76.0416C48.8463 76.3508 48.9583 76.653 49.1633 76.8255L50.5184 77.9658C50.7023 78.1206 50.8128 78.3811 50.8128 78.6601V85.3059",
    stroke: "#AA5939",
    strokeWidth: 1.95659,
    id: "path25",
    style: {
      stroke: "#f47a00",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.4198,
    cy: 35.0069,
    r: 1.06041,
    fill: "#AA5939",
    id: "circle25",
    style: {
      fill: "#f47a00",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.8312,
    cy: 35.0069,
    r: 1.06041,
    fill: "#AA5939",
    id: "circle26",
    style: {
      fill: "#f47a00",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5208 5.95386L70.1097 8.62352M98.5754 23.1423L80.4786 29.8656M24.0249 5.95386L30.0447 12.8521M13.0828 1.62671L28.8947 16.5417M4.18481 31.5562L24.9263 35.0371M6.22894 61.3655L22.8225 53.8295M93.5252 29.3926L84.026 31.8809M80.8714 47.4316L97.3295 53.2366",
    stroke: "#AA5939",
    strokeWidth: 1.9672,
    strokeLinecap: "round",
    id: "path26",
    style: {
      stroke: "#f47a00",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2495 37.7959L38.8218 48.0161",
    stroke: "#AA5939",
    strokeWidth: 2.3585,
    strokeLinecap: "round",
    id: "path27",
    style: {
      stroke: "#f47a00",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0063 37.7959L68.434 48.0161",
    stroke: "#AA5939",
    strokeWidth: 2.3585,
    strokeLinecap: "round",
    id: "path28",
    style: {
      stroke: "#f47a00",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0464 11.4259C83.3071 12.5088 80.5525 16.2321 80.7768 16.5148C80.9621 16.7483 84.624 13.7491 85.6607 12.9463C86.8242 12.0453 87.2976 11.2934 86.4479 10.4932C85.5982 9.69295 84.876 10.2106 84.0464 11.4259Z",
    fill: "#AA5939",
    id: "path29",
    style: {
      fill: "#f47a00",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1281 46.4941C18.3758 46.091 22.8339 44.8355 22.8297 44.4746C22.8263 44.1765 18.0947 44.3039 16.7834 44.3034C15.3119 44.3029 14.4771 44.6072 14.6585 45.7602C14.8399 46.9132 15.7278 46.9465 17.1281 46.4941Z",
    fill: "#AA5939",
    id: "path30",
    style: {
      fill: "#f47a00",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4393 7.40909C93.723 9.31454 83.951 15.8608 84.0909 16.3681C84.2064 16.7871 95.0133 11.5483 98.021 10.1473C101.396 8.57496 103.201 7.25101 102.369 5.80987C101.536 4.36872 99.4877 5.27071 96.4393 7.40909Z",
    fill: "#AA5939",
    id: "path31",
    style: {
      fill: "#f47a00",
      fillOpacity: 1
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs31"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_6453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106.632,
    height: 85.3057,
    fill: "white",
    transform: "translate(0.183838)",
    id: "rect31"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLts3);
export default __webpack_public_path__ + "static/media/Icon_LTS3.943588ee29031f845b9dbe63ae60e0ee.svg";
export { ForwardRef as ReactComponent };